(function () {
  'use strict';

  /* ---- config ---- */
  var HANDLE = 'breathe-2-0-gulf-cup-edition';
  var AR_TITLE = 'تيشيرت بريث 2.0 – إصدار محدود لكأس الخليج';
  var TAG_TEXT_EN = 'Limited Edition';
  var TAG_TEXT_AR = 'قطع محدودة';
  var BADGE_TEXT_EN = 'LIMITED';
  var BADGE_TEXT_AR = 'قطع محدودة';
  var RATING = { score: '4.66', count: '108' };
  var FALLBACK_IMG = 'https://qynda.com/cdn/shop/files/1_fc44896e-32a5-4361-b84f-916795312b4c.jpg?v=1786527950&width=1600';
  var ARROW_L = 'https://cdn.shopify.com/s/files/1/0737/2069/3009/files/arrow-left-circle_4_3.png?v=1764574754';
  var ARROW_R = 'https://cdn.shopify.com/s/files/1/0737/2069/3009/files/arrow-left-circle_4_2.png?v=1764574754';

  /* ---- language & locale detection ---- */
  function isAr() {
    var docEl = document.documentElement;
    var lang = (docEl.getAttribute('lang') || '').toLowerCase();
    var dir = (docEl.getAttribute('dir') || document.dir || '').toLowerCase();
    var locale = (window.Shopify && Shopify.locale ? Shopify.locale : '').toLowerCase();
    var path = (location.pathname || '').toLowerCase();
    return lang.indexOf('ar') === 0 || dir === 'rtl' || locale.indexOf('ar') === 0 || /^\/ar(\/|$)/i.test(path);
  }
  var IS_AR = isAr();

  var rootPrefix = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root.replace(/\/$/, '') : (IS_AR ? '/ar' : ''));
  var PDP = rootPrefix + '/products/' + HANDLE;
  var CART_URL = rootPrefix + '/cart';

  /* nation identity: matcher, IP code, label, QYNDA per-nation palette, mini flag */
  var NATIONS = [
    { key: 'kuwait',  match: /kuwait|كويت/i,              cc: 'KW', labelEn: 'Kuwait',  labelAr: 'الكويت',   pri: '#2f57ac', dark: '#16234f', flag: 'linear-gradient(90deg,#111 0 20%,transparent 20%),linear-gradient(#007A3D 0 33.3%,#fff 0 66.6%,#CE1126 0)' },
    { key: 'ksa',     match: /(ksa|saudi|سعود)/i,        cc: 'SA', labelEn: 'KSA',     labelAr: 'السعودية', pri: '#45654d', dark: '#20342a', flag: '#046A38' },
    { key: 'oman',    match: /oman|عمان|عُمان/i,         cc: 'OM', labelEn: 'Oman',    labelAr: 'عُمان',    pri: '#b53f37', dark: '#43140f', flag: 'linear-gradient(90deg,#C8102E 0 30%,transparent 30%),linear-gradient(#fff 0 33.3%,#C8102E 0 66.6%,#007A3D 0)' },
    { key: 'bahrain', match: /bahrain|بحرين/i,           cc: 'BH', labelEn: 'Bahrain', labelAr: 'البحرين',  pri: '#c8323a', dark: '#5e0f16', flag: 'linear-gradient(90deg,#fff 0 32%,#CE1126 0)' },
    { key: 'uae',     match: /(uae|emirat|امارات|إمارات)/i, cc: 'AE', labelEn: 'UAE', labelAr: 'الإمارات', pri: '#1c1c1c', dark: '#000000', flag: 'linear-gradient(90deg,#CE1126 0 25%,transparent 25%),linear-gradient(#007A3D 0 33.3%,#fff 0 66.6%,#111 0)' },
    { key: 'qatar',   match: /qatar|قطر/i,               cc: 'QA', labelEn: 'Qatar',   labelAr: 'قطر',      pri: '#8a1538', dark: '#4d0c1f', flag: 'linear-gradient(90deg,#fff 0 30%,#8A1538 0)' }
  ];
  var NEUTRAL = { key: '', match: /^$/, cc: '', labelEn: '', labelAr: '', pri: '#16224c', dark: '#0e1735', flag: '#16224c' };

  function foldAr(s) {
    return String(s || '')
      .replace(/[\u064B-\u065F\u0670]/g, '')
      .replace(/[أإآا]/g, 'ا')
      .replace(/ى/g, 'ي')
      .replace(/ة/g, 'ه')
      .replace(/\s+/g, '')
      .toLowerCase();
  }

  function metaFor(val) {
    if (!val) return NEUTRAL;
    var raw = String(val).trim();
    var folded = foldAr(raw);
    for (var i = 0; i < NATIONS.length; i++) {
      var n = NATIONS[i];
      if (n.match.test(raw) || n.match.test(folded)) return n;
    }
    return NEUTRAL;
  }

  function nationDisplayName(meta, val) {
    if (isAr()) {
      return (meta && meta.labelAr) || (meta && meta.labelEn) || val;
    }
    return (meta && meta.labelEn) || val;
  }

  /* ---- kill previous ---- */
  var old = document.getElementById('qgc-widget'); if (old) old.remove();
  var oldStyle = document.getElementById('qgc-style'); if (oldStyle) oldStyle.remove();

  /* ---- styles ---- */
  var css = [
    '#qgc-widget{--pri:#2f57ac;--pri-d:#16234f;--ink:#171a2b;--mut:#68708c;--line:#e7eaf3;position:fixed;left:20px;bottom:20px;z-index:2147483000;font-family:Inter,"Helvetica Neue",Arial,sans-serif;-webkit-font-smoothing:antialiased}',
    '#qgc-widget.qgc-rtl, html[dir="rtl"] #qgc-widget, html[lang*="ar"] #qgc-widget{font-family:"Wallop","Noto Kufi Arabic","Cairo",Inter,system-ui,-apple-system,sans-serif;direction:rtl}',

    '#qgc-toggle{position:relative;z-index:2;display:flex;align-items:center;gap:10px;background:linear-gradient(135deg,var(--pri),var(--pri-d));color:#fff;border:0;border-radius:40px;padding:12px 20px 12px 16px;cursor:pointer;font-size:14px;font-weight:700;letter-spacing:.2px;box-shadow:0 8px 26px rgba(16,26,61,.38);transition:transform .18s ease,box-shadow .18s ease,background .3s ease}',
    '#qgc-widget.qgc-rtl #qgc-toggle, html[dir="rtl"] #qgc-toggle, html[lang*="ar"] #qgc-toggle{padding:12px 16px 12px 20px;direction:rtl}',
    '#qgc-toggle:hover{transform:translateY(-2px);box-shadow:0 12px 32px rgba(16,26,61,.46)}',
    '#qgc-toggle svg{width:22px;height:22px;flex:0 0 auto}',
    '#qgc-dot{position:absolute;top:-3px;right:-3px;width:14px;height:14px;border-radius:50%;background:#e23744;border:2px solid #fff;box-shadow:0 0 0 0 rgba(226,55,68,.55);animation:qgc-pulse 1.9s infinite}',
    '#qgc-widget.qgc-rtl #qgc-dot, html[dir="rtl"] #qgc-dot, html[lang*="ar"] #qgc-dot{right:auto;left:-3px}',
    '@keyframes qgc-pulse{0%{box-shadow:0 0 0 0 rgba(226,55,68,.55)}70%{box-shadow:0 0 0 9px rgba(226,55,68,0)}100%{box-shadow:0 0 0 0 rgba(226,55,68,0)}}',

    '#qgc-overlay{position:fixed;inset:0;background:rgba(10,14,30,.55);opacity:0;pointer-events:none;transition:opacity .22s ease;z-index:1}',
    '#qgc-widget.open #qgc-overlay{opacity:1;pointer-events:auto}',
    '#qgc-pop{position:absolute;z-index:2;left:0;bottom:62px;width:340px;max-height:calc(100vh - 92px);max-height:calc(100dvh - 92px);display:flex;flex-direction:column;background:#fff;overflow:hidden;-webkit-mask-image:-webkit-radial-gradient(#fff,#000);mask-image:radial-gradient(#fff,#000);box-shadow:0 20px 60px rgba(15,23,45,.32);border:1px solid var(--line);opacity:0;transform:translateY(10px) scale(.98);transform-origin:bottom left;pointer-events:none;transition:opacity .2s ease,transform .2s ease}',
    '#qgc-widget.qgc-rtl #qgc-pop, html[dir="rtl"] #qgc-pop, html[lang*="ar"] #qgc-pop{direction:rtl;text-align:right}',
    '#qgc-widget.open #qgc-pop{opacity:1;transform:translateY(0) scale(1);pointer-events:auto}',
    '#qgc-widget.open #qgc-dot{display:none}',

    '#qgc-close{position:absolute;right:12px;top:12px;width:32px;height:32px;border:0;border-radius:50%;background:rgba(255,255,255,.92);color:#171a2b;line-height:1;cursor:pointer;z-index:6;box-shadow:0 2px 10px rgba(0,0,0,.18);display:flex;align-items:center;justify-content:center}',
    '#qgc-widget.qgc-rtl #qgc-close, html[dir="rtl"] #qgc-close, html[lang*="ar"] #qgc-close{right:auto;left:12px}',
    '#qgc-close svg{width:16px;height:16px;display:block}',
    '#qgc-close:hover{background:#fff}',

    '#qgc-gal{position:relative;width:100%;height:300px;flex:0 0 auto;background:#0d1226;overflow:hidden;direction:ltr!important}',
    '#qgc-track{display:flex;height:100%;will-change:transform;touch-action:pan-y;direction:ltr!important}',
    '#qgc-track img{flex:0 0 100%;width:100%;height:100%;object-fit:contain;user-select:none;-webkit-user-drag:none;pointer-events:none}',
    '#qgc-badge{position:absolute;left:12px;top:12px;z-index:4;background:var(--pri-d);color:#fff;font-size:11px;font-weight:800;letter-spacing:1px;padding:6px 11px;border-radius:0;transition:background .3s ease}',
    '#qgc-widget.qgc-rtl #qgc-badge, html[dir="rtl"] #qgc-badge, html[lang*="ar"] #qgc-badge{left:auto;right:12px;letter-spacing:0}',
    '.qgc-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:4;width:42px;height:42px;border:0;border-radius:50%;background:none;padding:0;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:transform .12s ease}',
    '.qgc-arrow:hover{transform:translateY(-50%) scale(1.06)}',
    '.qgc-arrow img{width:100%;height:100%;display:block;filter:drop-shadow(0 2px 6px rgba(0,0,0,.35))}',
    '.qgc-arrow.qgc-fb{background:rgba(255,255,255,.92);color:#111;font-size:22px;font-weight:800;box-shadow:0 2px 10px rgba(0,0,0,.2)}',
    '#qgc-prev{left:8px}#qgc-next{right:8px}',
    '#qgc-dots{display:flex;justify-content:center;gap:6px;padding:11px 0 1px;direction:ltr!important}',
    '#qgc-dots button{width:7px;height:7px;padding:0;border:0;border-radius:50%;background:#d3d8e6;cursor:pointer;transition:width .2s ease,background .2s ease}',
    '#qgc-dots button.on{width:18px;border-radius:0;background:var(--pri)}',

    '#qgc-body{padding:16px 18px 18px;flex:1 1 auto;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch}',
    '#qgc-rate{display:flex;align-items:center;gap:6px;font-size:12px;color:var(--mut);margin-bottom:6px}',
    '#qgc-rate b{color:var(--ink);font-weight:700}#qgc-rate .qgc-star{color:#f5a623;font-size:13px}',
    '#qgc-title{margin:0 0 6px;font-size:18px;font-weight:800;color:var(--ink);letter-spacing:.2px;line-height:1.25}',
    '#qgc-widget.qgc-rtl #qgc-title, html[dir="rtl"] #qgc-title, html[lang*="ar"] #qgc-title{letter-spacing:0}',
    '#qgc-price{font-size:18px;font-weight:800;color:var(--ink)}',
    '#qgc-ships{display:inline-flex;align-items:center;gap:6px;font-size:12px;color:var(--pri);font-weight:600;margin:6px 0 14px;transition:color .3s ease}#qgc-ships svg{width:13px;height:13px}',

    '.qgc-sec{margin-bottom:14px}',
    '.qgc-lbl{font-size:11px;font-weight:700;letter-spacing:.6px;color:var(--mut);text-transform:uppercase;margin-bottom:7px}',
    '#qgc-widget.qgc-rtl .qgc-lbl, html[dir="rtl"] .qgc-lbl, html[lang*="ar"] .qgc-lbl{letter-spacing:0;text-transform:none}',
    '#qgc-nat-current{display:flex;align-items:center;gap:9px;width:100%;padding:10px 12px;border:1.5px solid var(--pri);border-radius:0;background:#fff;cursor:pointer;font-size:13.5px;font-weight:800;color:var(--ink);transition:border-color .3s ease}',
    '#qgc-nat-current i{width:24px;height:16px;border-radius:0;flex:0 0 auto;box-shadow:0 0 0 1px rgba(0,0,0,.1);background-size:cover;background-position:center}',
    '#qgc-nat-current .chev{margin-left:auto;color:var(--pri);transition:transform .2s ease}',
    '#qgc-widget.qgc-rtl #qgc-nat-current .chev, html[dir="rtl"] #qgc-nat-current .chev, html[lang*="ar"] #qgc-nat-current .chev{margin-left:0;margin-right:auto}',
    '#qgc-nats-wrap.exp .chev{transform:rotate(180deg)}',
    '#qgc-nats{display:none;flex-wrap:wrap;gap:7px;margin-top:8px}',
    '#qgc-nats-wrap.exp #qgc-nats{display:flex}',
    '.qgc-nat{display:flex;align-items:center;gap:7px;padding:7px 11px 7px 8px;border:1.5px solid var(--line);background:#fff;border-radius:0;font-size:12.5px;font-weight:700;color:var(--ink);cursor:pointer;transition:all .14s ease}',
    '.qgc-nat:hover{border-color:#c3cbe2}',
    '.qgc-nat.on{border-color:var(--pri);box-shadow:inset 0 0 0 1px var(--pri)}',
    '.qgc-nat i{width:22px;height:15px;border-radius:0;flex:0 0 auto;box-shadow:0 0 0 1px rgba(0,0,0,.1);background-size:cover;background-position:center}',

    '#qgc-sizes{display:flex;flex-wrap:wrap;gap:7px}',
    '#qgc-sizes button{min-width:40px;padding:8px 6px;border:1.5px solid var(--line);background:#fff;border-radius:0;font-size:13px;font-weight:700;color:var(--ink);cursor:pointer;transition:all .14s ease;font-family:Inter,sans-serif}',
    '#qgc-sizes button:hover{border-color:#c3cbe2}',
    '#qgc-sizes button.on{border-color:var(--pri);background:var(--pri);color:#fff}',
    '#qgc-sizes button:disabled{opacity:.35;cursor:not-allowed;text-decoration:line-through}',

    '#qgc-actions{display:flex;gap:9px}',
    '.qgc-btn{flex:1; margin-bottom: 10px; text-align:center;text-decoration:none;padding:13px 8px;border-radius:0;font-size:13.5px;font-weight:800;letter-spacing:.3px;cursor:pointer;border:0;transition:transform .12s ease,background .2s ease,opacity .15s ease}',
    '#qgc-widget.qgc-rtl .qgc-btn, html[dir="rtl"] .qgc-btn, html[lang*="ar"] .qgc-btn{letter-spacing:0}',
    '.qgc-btn:active{transform:scale(.98)}',
    '#qgc-add{background:var(--pri);color:#fff}#qgc-add:hover{filter:brightness(.93)}',
    '#qgc-add.done{background:#1f9d55!important;filter:none}',
    '#qgc-add:disabled{opacity:.7;cursor:progress}',
    '#qgc-view{background:#eef1f8;color:var(--pri-d)}#qgc-view:hover{background:#e3e8f5}',

    '#qgc-toast{max-height:0;overflow:hidden;opacity:0;transition:all .25s ease}',
    '#qgc-toast.show{max-height:60px;opacity:1;margin-top:12px}',
    '#qgc-toast a{display:block;text-align:center;background:var(--pri-d);color:#fff;text-decoration:none;padding:11px;border-radius:0;font-size:13px;font-weight:800}',

    '#qgc-load{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:#0f1633;z-index:5}',
    '#qgc-load span{width:26px;height:26px;border:3px solid rgba(255,255,255,.25);border-top-color:#fff;border-radius:50%;animation:qgc-spin .8s linear infinite}',
    '@keyframes qgc-spin{to{transform:rotate(360deg)}}',
    '@media(max-width:600px){#qgc-widget{left:12px;bottom:12px}#qgc-pop{width:calc(100vw - 24px);max-width:340px;max-height:calc(100vh - 84px);max-height:calc(100dvh - 84px)}#qgc-gal{height:260px}}'
  ].join('');
  var style = document.createElement('style'); style.id = 'qgc-style'; style.textContent = css; document.head.appendChild(style);

  /* ---- shell ---- */
  var bolt = (function () {
    var INK = '#12183a';
    function pt(r, deg) { var a = deg * Math.PI / 180; return (12 + r * Math.cos(a)).toFixed(2) + ' ' + (12 + r * Math.sin(a)).toFixed(2); }
    function penta(cr, cd, r, rot) {
      var ca = cd * Math.PI / 180, ox = 12 + cr * Math.cos(ca), oy = 12 + cr * Math.sin(ca), d = 'M';
      for (var k = 0; k < 5; k++) { var a = (rot + k * 72) * Math.PI / 180; d += (k ? 'L' : '') + (ox + r * Math.cos(a)).toFixed(2) + ' ' + (oy + r * Math.sin(a)).toFixed(2) + ' '; }
      return d + 'Z';
    }
    var central = penta(0, 0, 3.2, -90), Es = [-54, 18, 90, 162, 234], rims = '', seams = '';
    Es.forEach(function (E) { rims += '<path d="' + penta(8.5, E, 2.6, E + 180) + '"/>'; seams += 'M' + pt(2.59, E) + 'L' + pt(5.9, E); });
    return '<svg viewBox="0 0 24 24" fill="none">' +
      '<defs><clipPath id="qgcBall"><circle cx="12" cy="12" r="10"/></clipPath></defs>' +
      '<circle cx="12" cy="12" r="10" fill="#fff" stroke="' + INK + '" stroke-width="1"/>' +
      '<g clip-path="url(#qgcBall)" fill="' + INK + '"><path d="' + central + '"/>' + rims + '</g>' +
      '<path clip-path="url(#qgcBall)" d="' + seams + '" stroke="' + INK + '" stroke-width="1" stroke-linecap="round"/>' +
      '</svg>';
  })();
  var chevDown = '<svg class="chev" viewBox="0 0 24 24" width="16" height="16" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var tagIcon = '<svg viewBox="0 0 24 24" fill="none"><path d="M12 2.6L14 10L21.4 12L14 14L12 21.4L10 14L2.6 12L10 10Z" fill="currentColor"/></svg>';

  var widget = document.createElement('div'); widget.id = 'qgc-widget';
  if (IS_AR) {
    widget.classList.add('qgc-rtl');
    widget.setAttribute('dir', 'rtl');
  }

  var defaultNation = NATIONS[0];
  var defaultNationName = nationDisplayName(defaultNation, defaultNation.labelEn);
  var badgeText = IS_AR ? BADGE_TEXT_AR : BADGE_TEXT_EN;
  var tagText = IS_AR ? TAG_TEXT_AR : TAG_TEXT_EN;
  var titleInitial = IS_AR ? AR_TITLE : 'Breathe 2.0 &ndash; Gulf Cup Edition';
  var nationLabelText = IS_AR ? 'الدولة' : 'Nation';
  var sizeLabelText = IS_AR ? 'اختيار المقاس' : 'Select size';
  var addToCartText = IS_AR ? 'أضف إلى السلة' : 'Add to Cart';
  var viewProductText = IS_AR ? 'عرض المنتج' : 'View Product';
  var toggleText = IS_AR ? 'كأس الخليج' : 'Gulf Cup';
  var reviewsWord = IS_AR ? 'تقييم' : 'reviews';
  var viewCartToastText = IS_AR ? 'عرض السلة &larr;' : 'View cart &rarr;';

  widget.innerHTML =
    '<div id="qgc-overlay"></div>' +
    '<div id="qgc-pop" role="dialog" aria-label="' + (IS_AR ? 'إصدار كأس الخليج' : 'Gulf Cup Edition') + '">' +
      '<button id="qgc-close" aria-label="' + (IS_AR ? 'إغلاق' : 'Close') + '"><svg viewBox="0 -960 960 960" width="16" height="16" fill="currentColor" aria-hidden="true"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg></button>' +
      '<div id="qgc-gal"><div id="qgc-badge">' + badgeText + '</div><div id="qgc-track"></div>' +
        '<button class="qgc-arrow" id="qgc-prev" aria-label="' + (IS_AR ? 'السابق' : 'Previous') + '"></button>' +
        '<button class="qgc-arrow" id="qgc-next" aria-label="' + (IS_AR ? 'التالي' : 'Next') + '"></button>' +
        '<div id="qgc-load"><span></span></div></div>' +
      '<div id="qgc-body">' +
        '<div id="qgc-dots"></div>' +
        '<div id="qgc-rate"><span class="qgc-star">&#9733;</span><b>' + RATING.score + '</b>&middot; ' + RATING.count + ' ' + reviewsWord + '</div>' +
        '<h3 id="qgc-title">' + titleInitial + '</h3>' +
        '<div id="qgc-price">$85</div>' +
        '<div id="qgc-ships">' + tagIcon + '<span>' + tagText + '</span></div>' +
        '<div class="qgc-sec" id="qgc-nats-wrap" style="display:none"><div class="qgc-lbl">' + nationLabelText + '</div>' +
          '<button id="qgc-nat-current" type="button"><i id="qgc-nat-flag"></i><span id="qgc-nat-name">' + defaultNationName + '</span>' + chevDown + '</button>' +
          '<div id="qgc-nats"></div></div>' +
        '<div class="qgc-sec" id="qgc-sizes-wrap" style="display:none"><div class="qgc-lbl">' + sizeLabelText + '</div><div id="qgc-sizes"></div></div>' +
        '<div id="qgc-actions">' +
          '<button class="qgc-btn" id="qgc-add">' + addToCartText + '</button>' +
          '<a class="qgc-btn" id="qgc-view" href="' + PDP + '">' + viewProductText + '</a>' +
        '</div>' +
        '<div id="qgc-toast"><a href="' + CART_URL + '">' + viewCartToastText + '</a></div>' +
      '</div>' +
    '</div>' +
    '<button id="qgc-toggle">' + bolt + '<span>' + toggleText + '</span><span id="qgc-dot"></span></button>';
  document.body.appendChild(widget);

  var $ = function (id) { return document.getElementById(id); };
  var widgetEl = widget, pop = $('qgc-pop'), toggle = $('qgc-toggle');
  toggle.addEventListener('click', function () { widgetEl.classList.toggle('open'); });
  $('qgc-close').addEventListener('click', function () { widgetEl.classList.remove('open'); });
  $('qgc-overlay').addEventListener('click', function () { widgetEl.classList.remove('open'); });
  document.addEventListener('click', function (e) { if (!widgetEl.contains(e.target)) widgetEl.classList.remove('open'); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') widgetEl.classList.remove('open'); });

  /* ---- hide on the product's own page (it just promotes this product) ---- */
  function onOwnPage() { return new RegExp('/products/' + HANDLE.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?:/|$)').test(location.pathname); }
  function syncVisibility() { var hide = onOwnPage(); widgetEl.style.display = hide ? 'none' : ''; if (hide) widgetEl.classList.remove('open'); }
  syncVisibility();
  setInterval(syncVisibility, 600);
  window.addEventListener('popstate', syncVisibility);
  window.addEventListener('pageshow', syncVisibility);

  /* ---- lock the page behind while the popup is open ---- */
  (function () {
    var docEl = document.documentElement, body = document.body, scrollY = 0, locked = false;
    function lock() {
      if (locked) return; locked = true;
      scrollY = window.pageYOffset || docEl.scrollTop || 0;
      body.style.top = -scrollY + 'px';
      body.style.position = 'fixed'; body.style.left = '0'; body.style.right = '0'; body.style.width = '100%';
      docEl.style.overflow = 'hidden';
    }
    function unlock() {
      if (!locked) return; locked = false;
      body.style.position = ''; body.style.top = ''; body.style.left = ''; body.style.right = ''; body.style.width = '';
      docEl.style.overflow = '';
      window.scrollTo(0, scrollY);
    }
    // iOS: block touch scroll on the page but allow it inside the popup body
    function onTouchMove(e) { var b = $('qgc-body'); if (!(b && b.contains(e.target))) e.preventDefault(); }
    new MutationObserver(function () {
      if (widgetEl.classList.contains('open')) { lock(); document.addEventListener('touchmove', onTouchMove, { passive: false }); }
      else { unlock(); document.removeEventListener('touchmove', onTouchMove, { passive: false }); }
    }).observe(widgetEl, { attributes: true, attributeFilter: ['class'] });
  })();

  function theme(m) { widgetEl.style.setProperty('--pri', m.pri); widgetEl.style.setProperty('--pri-d', m.dark); }
  theme(defaultNation);

  // circular arrow assets with graceful fallback
  function fillArrow(btn, src, fb) {
    var img = document.createElement('img'); img.src = src; img.alt = '';
    img.addEventListener('error', function () { btn.classList.add('qgc-fb'); btn.textContent = fb; });
    btn.appendChild(img);
  }
  fillArrow($('qgc-prev'), ARROW_L, '\u2039');
  fillArrow($('qgc-next'), ARROW_R, '\u203A');

  /* ---- gallery ---- */
  var track = $('qgc-track'), dotsWrap = $('qgc-dots');
  var slides = [], idx = 0, autoTimer = null;
  function norm(u) { return (u && u.indexOf('//') === 0) ? location.protocol + u : u; }
  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try {
        var fmt = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) ||
                  (window.Shopify && Shopify.money_format) ||
                  '${{amount}}';
        return Shopify.formatMoney(cents, fmt).replace(/\.00$/, '');
      } catch (e) {}
    }
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(isAr() ? 'ar' : undefined, { style: 'currency', currency: cur }).format(cents / 100).replace(/\.00$/, '');
    } catch (e) {
      return '$' + (cents / 100).toFixed(0);
    }
  }
  function go(i) {
    if (!slides.length) return;
    idx = (i + slides.length) % slides.length;
    track.style.transition = 'transform .35s cubic-bezier(.4,0,.2,1)';
    track.style.transform = 'translateX(' + (-idx * $('qgc-gal').clientWidth) + 'px)';
    Array.prototype.forEach.call(dotsWrap.children, function (d, j) { d.classList.toggle('on', j === idx); });
  }
  function buildGallery(imgs) {
    track.innerHTML = ''; dotsWrap.innerHTML = ''; slides = imgs.slice();
    imgs.forEach(function (src, j) {
      var im = document.createElement('img'); im.src = src; im.alt = (isAr() ? 'كأس الخليج ' : 'Gulf Cup ') + (j + 1); track.appendChild(im);
      var d = document.createElement('button'); d.setAttribute('aria-label', (isAr() ? 'شريحة ' : 'Slide ') + (j + 1));
      d.addEventListener('click', function () { go(j); rest(); }); dotsWrap.appendChild(d);
    });
    var multi = imgs.length > 1;
    $('qgc-prev').style.display = $('qgc-next').style.display = dotsWrap.style.display = multi ? '' : 'none';
    go(0); if (multi) auto();
  }
  function auto() { clearInterval(autoTimer); autoTimer = setInterval(function () { go(idx + 1); }, 4500); }
  function rest() { clearInterval(autoTimer); setTimeout(auto, 9000); }
  $('qgc-prev').addEventListener('click', function () { go(idx - 1); rest(); });
  $('qgc-next').addEventListener('click', function () { go(idx + 1); rest(); });
  window.addEventListener('resize', function () { track.style.transition = 'none'; go(idx); });
  var dragging = false, startX = 0, base = 0;
  track.addEventListener('pointerdown', function (e) { dragging = true; startX = e.clientX; base = -idx * $('qgc-gal').clientWidth; track.style.transition = 'none'; clearInterval(autoTimer); track.setPointerCapture(e.pointerId); });
  track.addEventListener('pointermove', function (e) { if (dragging) track.style.transform = 'translateX(' + (base + (e.clientX - startX)) + 'px)'; });
  function endDrag(e) { if (!dragging) return; dragging = false; var dx = e.clientX - startX; if (Math.abs(dx) > 45) go(dx < 0 ? idx + 1 : idx - 1); else go(idx); rest(); }
  track.addEventListener('pointerup', endDrag); track.addEventListener('pointercancel', endDrag);

  /* ---- variants / nation / size ---- */
  var PRODUCT = null, sel = { nation: null, size: null, variant: null };
  var userTouched = false, explicitUrl = false;
  function param(n) { return new URLSearchParams(location.search).get(n); }

  var reNation = /nation|country|team|color|colour|الدولة|دولة|البلد|بلد|الفريق|اللون/i;
  var reSize = /size|المقاس|مقاس|الحجم|حجم/i;

  function optIndex(re) {
    if (!PRODUCT || !PRODUCT.options) return -1;
    for (var i = 0; i < PRODUCT.options.length; i++) {
      var name = (PRODUCT.options[i].name || PRODUCT.options[i] || '').toString();
      if (re.test(name)) return i;
    }
    return -1;
  }
  function getNationIndex() {
    var idx = optIndex(reNation);
    if (idx >= 0) return idx;
    if (PRODUCT && PRODUCT.options && PRODUCT.options.length >= 1) return 0;
    return -1;
  }
  function getSizeIndex() {
    var idx = optIndex(reSize);
    if (idx >= 0) return idx;
    if (PRODUCT && PRODUCT.options && PRODUCT.options.length >= 2) return 1;
    return -1;
  }
  function optVal(v, i) { return i < 0 ? null : v['option' + (i + 1)]; }

  function updateView() {
    var viewBtn = $('qgc-view');
    if (!viewBtn) return;
    if (sel.variant) {
      viewBtn.href = PDP + '?variant=' + sel.variant.id;
    } else if (sel.nation) {
      viewBtn.href = PDP + '?nation=' + encodeURIComponent(sel.nation);
    } else {
      viewBtn.href = PDP;
    }
  }
  function match() {
    var nI = getNationIndex(), sI = getSizeIndex(), add = $('qgc-add');
    add.classList.remove('done'); $('qgc-toast').classList.remove('show');
    if (sI >= 0 && !sel.size) {
      add.disabled = false;
      add.textContent = isAr() ? 'اختر المقاس' : 'Select size';
      sel.variant = null;
      updateView();
      return;
    }
    var meta = metaFor(sel.nation);
    var pick = PRODUCT.variants.filter(function (v) {
      var vNation = optVal(v, nI);
      var matchNation = nI < 0 || !sel.nation || vNation === sel.nation || (meta !== NEUTRAL && metaFor(vNation) === meta);
      var matchSize = sI < 0 || !sel.size || optVal(v, sI) === sel.size;
      return matchNation && matchSize;
    });
    sel.variant = pick.filter(function (v) { return v.available; })[0] || pick[0] || null;
    add.disabled = false;
    if (sel.variant && sel.variant.available === false) {
      add.textContent = isAr() ? 'نفدت الكمية' : 'Sold out';
    } else {
      add.textContent = isAr() ? 'أضف إلى السلة' : 'Add to Cart';
    }
    if (sel.variant) $('qgc-price').textContent = money(sel.variant.price);
    updateView();
  }
  function buildSizes() {
    var sI = getSizeIndex(); if (sI < 0) return;
    var nI = getNationIndex(), order = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'], seen = [];
    PRODUCT.variants.forEach(function (v) { var s = optVal(v, sI); if (s && seen.indexOf(s) < 0) seen.push(s); });
    seen.sort(function (a, b) {
      var x = order.indexOf(String(a).toUpperCase()), y = order.indexOf(String(b).toUpperCase());
      return (x < 0 ? 99 : x) - (y < 0 ? 99 : y);
    });
    var box = $('qgc-sizes'); box.innerHTML = ''; var stillValid = false;
    seen.forEach(function (s) {
      var b = document.createElement('button'); b.textContent = s;
      var meta = metaFor(sel.nation);
      var avail = PRODUCT.variants.some(function (v) {
        var vNation = optVal(v, nI);
        var matchNation = nI < 0 || !sel.nation || vNation === sel.nation || (meta !== NEUTRAL && metaFor(vNation) === meta);
        return optVal(v, sI) === s && v.available && matchNation;
      });
      if (!avail) b.disabled = true;
      if (s === sel.size && avail) { b.classList.add('on'); stillValid = true; }
      b.addEventListener('click', function () {
        if (b.disabled) return;
        userTouched = true;
        sel.size = s;
        Array.prototype.forEach.call(box.children, function (c) { c.classList.toggle('on', c === b); });
        match();
      });
      box.appendChild(b);
    });
    if (!stillValid) sel.size = null;
    $('qgc-sizes-wrap').style.display = '';
  }
  var NATION_ALIASES = {
    KW: ['kuwait', 'كويت', 'الكويت'],
    SA: ['ksa', 'saudi', 'سعود', 'السعودية', 'سعودية'],
    OM: ['oman', 'عمان', 'عُمان'],
    BH: ['bahrain', 'بحرين', 'البحرين'],
    AE: ['uae', 'emirat', 'united arab', 'امارات', 'الامارات', 'إمارات', 'الإمارات'],
    QA: ['qatar', 'قطر']
  };
  function nationAliases(val) {
    var meta = metaFor(val), out = [
      String(val).toLowerCase(),
      (meta.labelEn || '').toLowerCase(),
      (meta.labelAr || '').toLowerCase()
    ];
    (NATION_ALIASES[meta.cc] || []).forEach(function (a) { out.push(a.toLowerCase()); });
    return out.filter(Boolean);
  }
  function galleryFor(val) {
    var nI = getNationIndex();
    if (nI < 0) return (PRODUCT.images || []).map(norm);
    var aliases = nationAliases(val), out = [];
    function add(s) { s = norm(s); if (s && out.indexOf(s) < 0) out.push(s); }
    function altHit(alt) { alt = (alt || '').toLowerCase(); return aliases.some(function (a) { return a && alt.indexOf(a) >= 0; }); }
    // 1. this nation's variant hero image (always correct, even if alt is odd)
    var meta = metaFor(val);
    PRODUCT.variants.forEach(function (v) {
      var vOpt = optVal(v, nI);
      if ((vOpt === val || (meta !== NEUTRAL && metaFor(vOpt) === meta)) && v.featured_image && v.featured_image.src) {
        add(v.featured_image.src);
      }
    });
    // 2. every media whose alt names this nation -> the full angle set
    (PRODUCT.media || []).forEach(function (m) {
      if (!m) return; var src = m.src || (m.preview_image && m.preview_image.src);
      if (src && altHit(m.alt)) add(src);
    });
    // 3. also scan plain images by matching against media alt map (belt + suspenders)
    if (out.length < 2) (PRODUCT.images || []).forEach(function (u) {
      var m = (PRODUCT.media || []).filter(function (x) { return x && (x.src === u || (x.preview_image && x.preview_image.src === u)); })[0];
      if (m && altHit(m.alt)) add(u);
    });
    if (!out.length) (PRODUCT.images || []).forEach(add); // last resort
    return out;
  }
  function applyNation(val) {
    sel.nation = val; var meta = metaFor(val); theme(meta);
    $('qgc-nat-flag').style.background = meta.flag; $('qgc-nat-flag').style.backgroundSize = 'cover';
    $('qgc-nat-name').textContent = nationDisplayName(meta, val);
    Array.prototype.forEach.call($('qgc-nats').children, function (c) { c.classList.toggle('on', c._val === val); });
    buildGallery(galleryFor(val));
    buildSizes(); match();
  }
  function buildNations() {
    var nI = getNationIndex(); if (nI < 0) return;
    var vals = []; PRODUCT.variants.forEach(function (v) { var x = optVal(v, nI); if (x && vals.indexOf(x) < 0) vals.push(x); });
    var grid = $('qgc-nats'); grid.innerHTML = '';
    vals.forEach(function (val) {
      var meta = metaFor(val), b = document.createElement('button'); b.className = 'qgc-nat'; b._val = val;
      var flag = document.createElement('i'); flag.style.background = meta.flag; flag.style.backgroundSize = 'cover';
      var span = document.createElement('span'); span.textContent = nationDisplayName(meta, val);
      b.appendChild(flag); b.appendChild(span);
      b.addEventListener('click', function () { userTouched = true; applyNation(val); $('qgc-nats-wrap').classList.remove('exp'); });
      grid.appendChild(b);
    });
    $('qgc-nat-current').onclick = function () { $('qgc-nats-wrap').classList.toggle('exp'); };
    $('qgc-nats-wrap').style.display = '';
  }
  function initSelection() {
    var nI = getNationIndex(), sI = getSizeIndex(), vId = param('variant'), nParam = param('nation'), v0 = null;
    if (vId) v0 = PRODUCT.variants.filter(function (v) { return String(v.id) === String(vId); })[0];
    if (!v0 && nParam && nI >= 0) {
      var nMeta = metaFor(nParam);
      v0 = PRODUCT.variants.filter(function (v) {
        var opt = optVal(v, nI);
        return v.available && (
          String(opt).toLowerCase().indexOf(nParam.toLowerCase()) === 0 ||
          (nMeta !== NEUTRAL && metaFor(opt) === nMeta)
        );
      })[0];
    }
    explicitUrl = !!(vId || nParam);
    if (!v0) v0 = PRODUCT.variants.filter(function (v) { return v.available; })[0] || PRODUCT.variants[0];
    if (v0) { sel.nation = optVal(v0, nI); sel.size = optVal(v0, sI); }
  }

  /* ---- IP geolocation pre-select ---- */
  function applyIpCountry(cc) {
    if (userTouched || explicitUrl || !PRODUCT || !cc) return;
    var entry = null; for (var i = 0; i < NATIONS.length; i++) if (NATIONS[i].cc === cc) { entry = NATIONS[i]; break; }
    if (!entry) return;
    var nI = getNationIndex(); if (nI < 0) return;
    var val = null;
    PRODUCT.variants.forEach(function (v) { var x = optVal(v, nI); if (x && !val && metaFor(x) === entry) val = x; });
    if (val && val !== sel.nation) applyNation(val);
  }
  function geolocate() {
    fetch('https://get.geojs.io/v1/ip/country.json').then(function (r) { return r.json(); })
      .then(function (d) { applyIpCountry(((d && d.country) || '').toUpperCase()); })
      .catch(function () {
        fetch('https://ipapi.co/country/').then(function (r) { return r.text(); })
          .then(function (t) { applyIpCountry((t || '').trim().toUpperCase()); }).catch(function () {});
      });
  }

  /* ---- add to cart -> open native cart drawer ---- */
  function openCartDrawer() {
    var toggle = document.querySelector('[aria-controls="cart-drawer"]');
    if (!toggle) toggle = Array.prototype.filter.call(document.querySelectorAll('[aria-controls]'), function (el) { return /cart/i.test(el.getAttribute('aria-controls') || ''); })[0];
    if (toggle) { toggle.click(); return true; }
    var d = document.querySelector('cart-drawer, #cart-drawer');
    if (d) {
      if (typeof d.show === 'function') { d.show(); return true; }
      if (typeof d.open === 'function') { d.open(); return true; }
      d.setAttribute('open', ''); d.style.display = 'block'; return true;
    }
    return false;
  }
  function injectDrawer(html) {
    var drawer = document.querySelector('cart-drawer, #cart-drawer'); if (!drawer || !html) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = tmp.querySelector('cart-drawer, #cart-drawer') || tmp;
    [['.cart-drawer__items'], ['.cart-drawer__footer'], ['.fs-widget']].forEach(function (sel) {
      var live = drawer.querySelector(sel[0]), nu = fresh.querySelector(sel[0]);
      if (live && nu) live.replaceWith(nu);
    });
    var lb = drawer.querySelector('.drawer-count-badge'), fb = fresh.querySelector('.drawer-count-badge');
    if (lb && fb) lb.textContent = fb.textContent;
  }
  function updateCartCount() {
    try { fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { document.querySelectorAll('.drawer-count-badge,.cart-count-bubble span,[data-cart-count],.cart-count').forEach(function (el) { if (el) el.textContent = c.item_count; }); }); } catch (e) {}
  }
  $('qgc-add').addEventListener('click', function () {
    var btn = this;
    if (!sel.variant) {
      if (getSizeIndex() >= 0 && !sel.size) { $('qgc-sizes-wrap').scrollIntoView({ block: 'nearest' }); return; }
      location.href = $('qgc-view').href; return;
    }
    btn.disabled = true; btn.textContent = isAr() ? 'جاري الإضافة...' : 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: sel.variant.id, quantity: 1 }], sections: ['cart-drawer'], sections_url: location.pathname })
    })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (data) {
        btn.textContent = isAr() ? 'تمت الإضافة \u2713' : 'Added \u2713'; btn.classList.add('done');
        ['cart:refresh', 'cart:updated', 'cart:change', 'cart:build', 'ajaxProduct:added'].forEach(function (ev) { document.dispatchEvent(new CustomEvent(ev)); });
        var opened = openCartDrawer();
        if (data && data.sections && data.sections['cart-drawer']) injectDrawer(data.sections['cart-drawer']);
        updateCartCount();
        if (opened) {
          setTimeout(function () { widgetEl.classList.remove('open'); btn.classList.remove('done'); btn.textContent = isAr() ? 'أضف إلى السلة' : 'Add to Cart'; btn.disabled = false; }, 500);
        } else {
          $('qgc-toast').classList.add('show'); btn.disabled = false;
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = isAr() ? 'عرض في صفحة المنتج' : 'View on product page';
        btn.onclick = function () { location.href = $('qgc-view').href; };
      });
  });

  /* ---- load ---- */
  function fallback() {
    buildGallery([FALLBACK_IMG]);
    $('qgc-load').style.display = 'none';
    $('qgc-add').textContent = isAr() ? 'اختر الخيارات' : 'Choose options';
    $('qgc-add').onclick = function () { location.href = PDP; };
  }

  function loadProduct() {
    var urlsToTry = [PDP + '.js', '/products/' + HANDLE + '.js'];
    function tryNext(i) {
      if (i >= urlsToTry.length) { fallback(); return; }
      fetch(urlsToTry[i], { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (p) {
          PRODUCT = p; $('qgc-load').style.display = 'none';
          $('qgc-title').textContent = isAr() ? AR_TITLE : (p.title || 'Breathe 2.0 – Gulf Cup Edition');
          var imgs = (p.images && p.images.length ? p.images : [FALLBACK_IMG]).map(norm);
          buildNations(); initSelection();
          $('qgc-price').textContent = money(p.price);
          if (sel.nation) applyNation(sel.nation); else { buildGallery(imgs); buildSizes(); match(); }
          if (!explicitUrl) geolocate();
        })
        .catch(function () { tryNext(i + 1); });
    }
    tryNext(0);
  }

  loadProduct();
})();